import { Alert, Button } from "antd";
import dayjs from "dayjs";

export default function PendingBar({ pending, onResolve }) {
  if (!pending.length) return null;

  return (
    <Alert
      type="warning"
      showIcon
      message={`${pending.length} ${
        pending.length === 1
          ? "atendimento pendente de registro"
          : "atendimentos pendentes de registro"
      }`}
      description={
        <div
          style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 4 }}>
          {pending.map((item) => (
            <Button key={item.id} size="small" onClick={() => onResolve(item)}>
              {item.seller_name} · {dayjs(item.created_at).format("HH:mm")}
            </Button>
          ))}
        </div>
      }
    />
  );
}
